import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import moment from "moment";
import { post, get, ajax } from "jquery";
import { useHistory } from 'react-router-dom';
import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';

import CustomModal from '../../components/common/modal/modal';
import ElementMessage from '../../components/common/elementmessage';
import ContentTitle from '../../components/common/container/title';
import Button from '../../components/forms/button';
import InlineData from '../../components/forms/inlinedata';
import * as CONST from '../../helpers/const';
import { isMobile } from 'react-device-detect';

import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja"; // the locale you want

import Translate from '../../components/common/translate';
import Utils from '../../helpers/utils';
import { set } from 'core-js/fn/dict';
const getTranslateValue = Utils.getTranslateValue;

const API = {
  GETCARTINFO: window.domainDir + "api/Facility/GetIryokikanInfo"
};

const IAC0101_Master = (props) => {
  let translate = useRef(null);
  let history = useHistory();

  const [functionAvailable, setFunctionAvailable] = useState(true);

  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [facilityName, setFacilityName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [email, setEmail] = useState("");
  const [kanjiLast, setKanjiLast] = useState("");
  const [kanjiFirst, setKanjiFirst] = useState("");
  const [kanaLast, setKanaLast] = useState("");
  const [kanaFirst, setKanaFirst] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [agreementChecked, setAgreementChecked] = useState(false);

  // M_Iryokikan other properties
  const [iryokikanData, setIryokikanData] = useState(null);

  const [isShowModalTable, setIsShowModalTable] = useState(false);
  const [translateSuccess, setTranslateSuccess] = useState(false);
  const [errors, setErrors] = useState({
    postalCode: false,
    address: false,
    facilityName: false,
    phoneNumber: false,
    kanjiLast: false,
    kanjiFirst: false,
    kanaLast: false,
    kanaFirst: false,
    email: false,
    confirmEmail: false,
    departmentName: false,
  })

  useEffect(() => {
    $("#loading").fadeIn();
    try {
      var raw = sessionStorage.getItem(CONST.SessionData.FACILITYINFO);
      if (!raw) return;
      var saved = JSON.parse(raw);
      const { PostalCode, Address, FacilityName, PhoneNumber, Fax, Email, ConfirmEmail, 
        KanjiLastName, KanjiFirstName, KanaLastName, KanaFirstName, DepartmentName, ...rest } = saved;
      setPostalCode(saved.PostalCode || "");
      setAddress(saved.Address || "");
      setFacilityName(saved.FacilityName || "");
      setPhoneNumber(saved.PhoneNumber || "");
      setFaxNumber(saved.Fax || "");
      setEmail(saved.Email || "");
      setConfirmEmail(saved.ConfirmEmail || "");
      setKanjiLast(saved.KanjiLastName || "");
      setKanjiFirst(saved.KanjiFirstName || "");
      setKanaLast(saved.KanaLastName || "");
      setKanaFirst(saved.KanaFirstName || "");
      setDepartmentName(saved.DepartmentName || "");
      setIryokikanData(rest || {});
    } catch (e) { }
    finally {
      $("#loading").fadeOut();
    }
  }, []);

  useEffect(() => {
    try {
      var model = getFilterParameters(); 
      var otherIryokikanData = iryokikanData;
      var combinedModel = {...model, ...(otherIryokikanData || {})};
      sessionStorage.setItem(CONST.SessionData.FACILITYINFO, JSON.stringify(combinedModel));
    } catch (e) { }
  }, [
    postalCode, address, facilityName, phoneNumber, faxNumber,
    email, confirmEmail, kanjiLast, kanjiFirst, kanaLast, kanaFirst,
    departmentName
  ]);

  function setStatusMessage(status, message) {
    Utils.scrollToTop();
    setStatus(status);
    setMessage(message);
  }

  function clearMessage() {
    setStatus("");
    setMessage("");
  }

  function getFilterParameters() {
        let model = {
            PostalCode: postalCode,
            Address: address,
            FacilityName: facilityName,
            PhoneNumber: phoneNumber,
            Fax: faxNumber,
            KanjiLastName: kanjiLast,
            KanjiFirstName: kanjiFirst,
            KanaLastName: kanaLast,
            KanaFirstName: kanaFirst,
            Email: email,
            ConfirmEmail: confirmEmail,
            DepartmentName: departmentName
        }

        return model;
    }

  function handleCheckParameters() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let newErrors = {};
    let hasError = false;

    newErrors.postalCode = Utils.isNullOrEmpty(postalCode.trim());
    newErrors.address = Utils.isNullOrEmpty(address.trim());
    newErrors.facilityName = Utils.isNullOrEmpty(facilityName.trim());

    const noSelected = newErrors.postalCode || newErrors.address || newErrors.facilityName;
    if (noSelected) hasError = true;

    newErrors.phoneNumber = Utils.isNullOrEmpty(phoneNumber.trim());
    if (newErrors.phoneNumber) hasError = true; 

    newErrors.kanjiLast = Utils.isNullOrEmpty(kanjiLast.trim());
    newErrors.kanjiFirst = Utils.isNullOrEmpty(kanjiFirst.trim());
    if (newErrors.kanjiLast || newErrors.kanjiFirst) hasError = true; 

    newErrors.kanaLast = Utils.isNullOrEmpty(kanaLast.trim());
    newErrors.kanaFirst = Utils.isNullOrEmpty(kanaFirst.trim());
    if (newErrors.kanaLast || newErrors.kanaFirst) hasError = true; 

    newErrors.email = Utils.isNullOrEmpty(email.trim()) || !emailRegex.test(email);
    newErrors.confirmEmail = Utils.isNullOrEmpty(confirmEmail.trim()) || !emailRegex.test(confirmEmail);
    if (newErrors.email || newErrors.confirmEmail) hasError = true;

    if (!Utils.isNullOrEmpty(email.trim()) && 
    !Utils.isNullOrEmpty(confirmEmail.trim()) &&
    email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase()
  ) {
    newErrors.email = true;
    newErrors.confirmEmail = true;
    hasError = true;
  }

    newErrors.departmentName = Utils.isNullOrEmpty(departmentName.trim());
    if (newErrors.departmentName) hasError = true; 

    newErrors.agreement = !agreementChecked;
    if (!agreementChecked) hasError = true;

    setErrors(newErrors);

    if (hasError) {
      let msg;

      if (noSelected) {
        msg = getTranslateValue(translate.current, "views.iac0101.selectfacility");
      } else if (newErrors.agreement && Object.values(newErrors).filter(x => x).length === 1) {
        msg = getTranslateValue(translate.current, "messages.common.consentinfo");
      } else {
        msg = getTranslateValue(translate.current, "messages.common.missingrequiredfield");
      }
        setStatusMessage(CONST.ApiResult.Error, msg);
        return;
    }

    clearMessage();
    history.push(`/Cart/Confirm`);
  }

  return (
    <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
      <ContentTitle active="#IAC0101" title={getTranslateValue(translate.current, "views.iac0101.confirmfacilityinfo")} />
      <div className="main-content">
        <div className="container-fluid" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          {
            null == message || "" == message ?
              null
              :
              <div style={{ marginLeft: '-20px', marginRight: '-20px', whiteSpace: 'pre-wrap' }}>
                <ElementMessage message={message} status={status} clearMessage={clearMessage.bind(this)} />
              </div>
          }
          {renderForm()}
          {renderFormActions()}
        </div>
      </div>
    </Translate>
  )

  function renderForm() {
    return (
      <div>
        {renderFacilityInfoForm()}
        {renderOrdererInfoForm()}
        {renderInfo()}
      </div>
    );
  }

  function renderFacilityInfoForm() {
    return (
      <div>
        <legend className="legend-hdr" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 10 }}>
          <span>{getTranslateValue(translate.current, "views.iac0101.facilityinfo")}</span>
          <span style={{ fontWeight: 'normal', fontSize: 12, color: '#666' }}>{getTranslateValue(translate.current, "views.iac0101.info1")}</span>
        </legend>
        <div className="row" style={{ marginBottom: 20 }}>
          <div className="col-xs-12">
            <div style={{ backgroundColor: '#EBF1DE', padding: '16px 12px', borderRadius: 4, textAlign: 'center' }}>
              <div style={{ marginBottom: 10, fontSize: 14 }}>
                {getTranslateValue(translate.current, "views.iac0101.info12")}
              </div>
              <Button color="Success" divClassName="" divStyle={{ width: '100%', display: 'flex', justifyContent: 'center' }} className="" onClick={() => {history.push(`/Cart/SelectFacilityInfo`)}}
                label={
                  <span>
                    {getTranslateValue(translate.current, "views.iac0101.searchfacilityname")}
                    <i className="fa fa-search" style={{ marginLeft: 8 }} />
                  </span>
                }
              />
            </div>
          </div>
        </div>
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.postalcode")}
          name="postalcode"
          value={postalCode}
          required={true}
          onChange={setPostalCode.bind(this)}
          containerType="label"
          maxLength="8"
          inputClass= {isMobile? "col-xs-12 input-group-text": null }
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.address")}
          name="address"
          value={address}
          required={true}
          onChange={setAddress.bind(this)}
          containerType="label"
          inputClass= {isMobile? "col-xs-12 input-group-text": null }
          style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.facilityname")}
          name="facilityname"
          value={facilityName}
          required={true}
          onChange={setFacilityName.bind(this)}
          containerType="label"
          inputClass= {isMobile? "col-xs-12 input-group-text": null }
          style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.phonenumber")}
          name="phonenumber"
          placeholder={getTranslateValue(translate.current, "views.iac0101.phonenumber")}
          description=""
          value={phoneNumber}
          required={true}
          onChange={setPhoneNumber.bind(this)}
          containerType="text"
          maxLength="16"
          style={{backgroundColor: errors.phoneNumber ? "pink" : "white"}}
          inputClass={isMobile? "col-md-5 col-sm-7 col-xs-12": null}
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.fax")}
          name="fax"
          placeholder={getTranslateValue(translate.current, "views.iac0101.fax")}
          description=""
          value={faxNumber}
          onChange={setFaxNumber.bind(this)}
          containerType="text"
          maxLength="12"
          inputClass={isMobile? "col-md-5 col-sm-7 col-xs-12": null}
        />
      </div>
    );
  }

  function renderOrdererInfoForm() {
    return (
      <div>
        <legend className="legend-hdr">{getTranslateValue(translate.current, "views.iac0101.ordererinfo")}</legend>
        {isMobile? renderKanjiNameMobile(): renderKanjiName()}
        {isMobile? renderKanaNameMobile(): renderKanaName()}  
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.email")}
          name="email"
          placeholder={getTranslateValue(translate.current, "views.iac0101.email")}
          description=""
          value={email}
          required={true}
          onChange={setEmail.bind(this)}
          containerType="text"
          maxLength="256"
          style={{backgroundColor: errors.email ? "pink" : "white"}}
          inputClass={isMobile? "col-md-5 col-sm-7 col-xs-12": null}
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.confirmemail")}
          name="confirmemail"
          placeholder={getTranslateValue(translate.current, "views.iac0101.confirmemail")}
          description=""
          value={confirmEmail}
          required={true}
          onChange={setConfirmEmail.bind(this)}
          containerType="text"
          maxLength="256"
          style={{backgroundColor: errors.confirmEmail ? "pink" : "white"}}
          inputClass={isMobile? "col-md-5 col-sm-7 col-xs-12": null}
        />
        <InlineData
          label={getTranslateValue(translate.current, "views.iac0101.departmentname")}
          name="departmentname"
          placeholder={getTranslateValue(translate.current, "views.iac0101.departmentname")}
          description={getTranslateValue(translate.current, "views.iac0101.info6")}
          value={departmentName}
          required={true}
          onChange={setDepartmentName.bind(this)}
          containerType="text"
          maxLength="100"
          style={{backgroundColor: errors.departmentName ? "pink" : "white"}}
          inputClass={isMobile? "col-md-5 col-sm-7 col-xs-12": null}
        />
      </div>
    );
  }

  function renderKanjiName() {
    return (
      <div className="row form-group">
        <div className="col-md-2 col-sm-3 col-xs-3 input-group-text">
          <label>{getTranslateValue(translate.current, "views.iac0101.kanjiname")}</label>
        </div>
        <div className="col-md-1 col-sm-2 col-xs-2 input-group-text" style={{ overflow: "hidden" }}>
          <img className="pull-right" style={{ paddingBottom: "6px" }} src={window.baseUrl +"/img/big%20bell/icon_hissu.png"} />
        </div>
        <div className="col-md-9 col-sm-7 col-xs-7">
          <div className="row">
            <div className="col-xs-3" style={{ marginBottom: 10, marginRight: 40 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '105%' }}>
                <span style={{ padding: '6px 40px 6px 0px', bbackground: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanjilastname")}
                </span>
                <input id="kanjiLast" type="text" maxLength="16" className="form-control" name="kanjiLast" value={kanjiLast} onChange={e => setKanjiLast(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanjiLast ? "pink" : "white" }} />
              </div>
            </div>
            <div className="col-xs-3" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '105%' }}>
                <span style={{ padding: '6px 40px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanjifirstname")}
                </span>
                <input id="kanjiFirst" type="text" maxLength="15" className="form-control" name="kanjiFirst" value={kanjiFirst} onChange={e => setKanjiFirst(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanjiFirst ? "pink" : "white" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderKanaName() {
    return (
      <div className="row form-group">
        <div className="col-md-2 col-sm-3 col-xs-3 input-group-text">
          <label>{getTranslateValue(translate.current, "views.iac0101.kananame")}</label>
        </div>
        <div className="col-md-1 col-sm-2 col-xs-2 input-group-text" style={{ overflow: "hidden" }}>
          <img className="pull-right" style={{ paddingBottom: "6px" }} src={window.baseUrl + "/img/big%20bell/icon_hissu.png"} />
        </div>
        <div className="col-md-9 col-sm-7 col-xs-7">
          <div className="row">
            <div className="col-xs-3" style={{ marginBottom: 10, marginRight: 40 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '105%' }}>
                <span style={{ padding: '6px 28px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanalastname")}
                </span>
                <input id="kanaLast" type="text" maxLength="16" className="form-control" name="kanaLast" value={kanaLast} onChange={e => setKanaLast(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanaLast ? "pink" : "white" }} />
              </div>
            </div>
            <div className="col-xs-3" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '105%' }}>
                <span style={{ padding: '6px 28px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanafirstname")}
                </span>
                <input id="kanaFirst" type="text" maxLength="15" className="form-control" name="kanaFirst" value={kanaFirst} onChange={e => setKanaFirst(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanaFirst ? "pink" : "white" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

function renderKanjiNameMobile() {
    return (
      <div className="row form-group">
        <div className="col-md-2 col-sm-3 col-xs-3 input-group-text">
          <label>{getTranslateValue(translate.current, "views.iac0101.kanjiname")}</label>
        </div>
        <div className="col-md-1 col-sm-2 col-xs-2 input-group-text" style={{ overflow: "hidden" }}>
          <img className="pull-right" style={{ paddingBottom: "6px" }} src={window.baseUrl + "/img/big%20bell/icon_hissu.png"} />
        </div>

        <div className="col-md-9 col-sm-7 col-xs-12">
          <div className="row">
            <div className="col-xs-6" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
                <span style={{ padding: '6px 10px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanjilastname")}
                </span>
                <input id="kanjiLast" type="text" maxLength="16" className="form-control" name="kanjiLast" value={kanjiLast} onChange={e => setKanjiLast(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanjiLast ? "pink" : "white", flex: 1 }} />
              </div>
            </div>
            <div className="col-xs-6" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
                <span style={{ padding: '6px 10px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanjifirstname")}
                </span>
                <input id="kanjiFirst" type="text" maxLength="15" className="form-control" name="kanjiFirst" value={kanjiFirst} onChange={e => setKanjiFirst(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanjiFirst ? "pink" : "white", flex: 1 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

 function renderKanaNameMobile() {
    return (
      <div className="row form-group">
        <div className="col-md-2 col-sm-3 col-xs-3 input-group-text">
          <label>{getTranslateValue(translate.current, "views.iac0101.kananame")}</label>
        </div>
        <div className="col-md-1 col-sm-2 col-xs-2 input-group-text" style={{ overflow: "hidden" }}>
          <img className="pull-right" style={{ paddingBottom: "6px" }} src={window.baseUrl +  "/img/big%20bell/icon_hissu.png"} />
        </div>
        <div className="col-md-9 col-sm-7 col-xs-12">
          <div className="row">
            {/* new row for mobile */}
            <div className="col-xs-6" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
                <span style={{ padding: '6px 10px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanalastname")}
                </span>
                <input id="kanaLast" type="text" maxLength="16" className="form-control" name="kanaLast" value={kanaLast} onChange={e => setKanaLast(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanaLast ? "pink" : "white", flex: 1 }} />
              </div>
            </div>
            {/* new row for mobile */}
            <div className="col-xs-6" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
                <span style={{ padding: '6px 10px 6px 0px', background: 'transparent', borderRight: 0, whiteSpace: 'nowrap' }}>
                  {getTranslateValue(translate.current, "views.iac0101.kanafirstname")}
                </span>
                <input id="kanaFirst" type="text" maxLength="15" className="form-control" name="kanaFirst" value={kanaFirst} onChange={e => setKanaFirst(e.target.value)} style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: errors.kanaFirst ? "pink" : "white", flex: 1 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderInfo() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', justifyContent: 'center', marginTop: '16px', marginBottom: '45px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img className="pull-right" style={{ marginRight: 20 }} src={window.baseUrl +  "/img/big%20bell/icon_hissu.png"} />
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input type="checkbox" checked={agreementChecked} onChange={e => setAgreementChecked(e.target.checked)} style={{ marginRight: '4px' }} />
          </label>
          <span>{getTranslateValue(translate.current, "views.iac0101.info2")}</span>
        </div>
        <div style={{ textAlign: 'center', maxWidth: '720px', fontSize: '13px', color: '#333' }}>
          <div>{getTranslateValue(translate.current, "views.iac0101.info3")}</div>
          <div style={{ marginTop: '8px' }}>
            <a href="https://www.okayama-taiho.co.jp/protection/" target="_blank" rel="noopener noreferrer" style={{ color: '#337ab7', textDecoration: 'underline', cursor: 'pointer' }}>
              {getTranslateValue(translate.current, "views.iac0101.info4")}
            </a>
            {' '}
            <span>{getTranslateValue(translate.current, "views.iac0101.info5")}</span>
          </div>
        </div>
      </div>
    );
  }

  function renderFormActions() {
    return (
      <div className="row form-group" style={{ marginTop: 10 }}>
        <div className="col-xs-4 text-left">
          <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.iac0101.back")} onClick={() => {history.push(`/Cart/List`)}} />
        </div>
        <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
          <Button color="Success" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.iac0101.confirm")} onClick={handleCheckParameters.bind(this)} />
        </div>
        {!isMobile && <div className="col-xs-4" />}
      </div>
    );
  }
}

export default IAC0101_Master;


// WEBPACK FOOTER //
// ./view/IAC0101/iac0101.jsx